import Filters from '@wwdev/product/filters';

class CustomFilters extends Filters {
	beforeCallback() {
		super.beforeCallback();
		showLoader();
		$('[package="cms-product"]').addClass('loading');
	}

	afterCallback() {
		super.afterCallback();
		hideLoader();
		$('[package="cms-product"]').removeClass('loading');
	}
}

export default CustomFilters;